import { AggWorldDataItem } from '@patsnap/synapse_domain'
import { analysisOneDimTableBuilder } from './BAnalysisOneDimTable'

export const BAnalysisWorldTable = analysisOneDimTableBuilder<AggWorldDataItem>('BAnalysisWorldTable')
